// Removes properties from an object where the value is undefined.
// Returns a new object without mutating the original.
export function filterUndefined(obj) {
  return Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(obj).filter(([_, v]) => v !== undefined),
  );
}
